export default __webpack_public_path__ + "static/media/linkedin.92d41f40.svg";